// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Us-z","giftOrPromoSelector":"Vs-z","disabled":"Ws-z","subTitle":"Xs-z","selectShipAddressMessage":"Ys-z","changePayment":"Zs-z"};